import {Moment} from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import {
  CalendarFilesByDate,
  CalendarInteraction,
  CalendarItem,
  LayeredCalendarItems,
} from 'calendar/CalendarConstants';

import {momentPropType} from './CalendarStore';
import WeekComponent from './WeekComponent';
import WeeklyFileActivity from './WeeklyFileActivity';

interface CalendarWeekProps {
  today: Moment;
  weekStart: Moment;
  interact: CalendarInteraction;
  showWeeklyFileActivity: boolean;
  files: CalendarFilesByDate;
  items: LayeredCalendarItems<CalendarItem>;
}

function CalendarWeek(props: CalendarWeekProps): JSX.Element {
  return (
    <div>
      <WeekComponent
        today={props.today}
        weekStart={props.weekStart}
        items={props.items}
        interact={props.interact}
        renderDate={(date) => <span title={date.format('YYYY-MM-DD')}>{date.format('D')}</span>}
      />
      {props.showWeeklyFileActivity && <WeeklyFileActivity files={props.files} weekStart={props.weekStart} />}
    </div>
  );
}

CalendarWeek.propTypes = {
  today: momentPropType.isRequired,
  weekStart: momentPropType.isRequired,
  items: PropTypes.arrayOf(PropTypes.array).isRequired,
  interact: PropTypes.shape({
    selectedCalendarItemDay: PropTypes.shape({
      id: PropTypes.string.isRequired,
      date: momentPropType.isRequired,
    }),
  }).isRequired,
  files: PropTypes.object.isRequired,
  showWeeklyFileActivity: PropTypes.bool.isRequired,
};

CalendarWeek.defaultProps = {
  showWeeklyFileActivity: true,
};

export default CalendarWeek;
